import { ApiTask } from "src/api/types";
import Button from "src/components/Button";
import Loader from "src/components/Loader";
import Layout from "src/components/layout/Layout";
import TabNav from "src/components/layout/TabNav";
import TaskEditableTitle from "src/components/tasks/TaskEditableTitle";
import TaskDetailFields from "src/components/tasks/detail/TaskDetailFields";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";
import useTaskTabs from "src/hooks/api/tasks/useTaskTabs";
import useElementSize from "src/hooks/useElementSize";
import useWindowSize from "src/hooks/useWindowSize";

interface TaskDetailWrapperProps {
	task: ApiTask;
	loading: boolean;
	children?: any;
	options?: {
		hideTabs?: boolean;
		hideFields?: boolean;
	};
}

const TaskDetailWrapper = ({
	task,
	loading,
	children,
	options,
}: TaskDetailWrapperProps) => {
	const { isTablet } = useWindowSize();
	const title = useElementSize();
	const wrapper = useElementSize();
	const { tabs } = useTaskTabs(task);
	const { status } = useTaskForm();
	const left = (wrapper.size.width - title.size.width) / 2;

	return (
		<Layout {...{ loading }} className=" ">
			{!loading && (
				<div
					ref={wrapper.ref}
					className="relative flex flex-col flex-1 w-full md:pb-12"
				>
					<div className={`${!isTablet && "container"}`}>
						<div className="md:pb-8 pb-4">
							<div className="flex items-center gap-2 mb-4">
								<Button
									iconOnly
									icon="fas fa-arrow-left"
									type="dark"
									to={`/tasks`}
								/>
								{task.type === "PUBLISHED" && (
									<Button
										iconOnly
										icon="fas fa-retweet"
										type="gray"
										to={`/tasks/create?repeat=${task?.hid}`}
									/>
								)}
							</div>
							<div ref={title.ref} className="md:mt-6">
								<TaskEditableTitle variant="large" />
							</div>
							{!options?.hideFields && (
								<TaskDetailFields className="md:mt-6" />
							)}
						</div>
					</div>
					<div className="overflow-auto flex flex-col flex-1">
						{!options?.hideTabs && (
							<div className="flex items-center mb-8">
								{!isTablet && (
									<div
										style={{ width: left }}
										className="flex w-full"
									></div>
								)}
								<div className="flex-1">
									<TabNav {...{ tabs }} type="company" />
								</div>
							</div>
						)}

						<div className="flex flex-col flex-1">{children}</div>
					</div>
					{status === "updating" && (
						<div className="fixed pointer-events-none right-0 bottom-0 z-[20]">
							<div className="p-8">
								<Loader />
							</div>
						</div>
					)}
				</div>
			)}
		</Layout>
	);
};

export default TaskDetailWrapper;
